import Box from "@mui/material/Box";
import ContactInfoList from "../../components/Profile/ContactInfo/ContactInfoList";
import DefaultTemplate from "../templates/DefaultTemplate";
import Grid from "@mui/material/Grid";
import { OverviewCard } from "../../components/Card/Card";
import PageTitle from "../../components/PageTitle/PageTitle";
import React from "react";
import { TEXT_DATA_UNAVAILABLE } from "../../config/common";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { connect } from "react-redux";
import { isStringOfLength } from "@pheaa/channels-component-library";
import { useTheme } from "@mui/material";
import {
	ContentContainerBottom,
	ContentContainerTop
} from "../../components/Container/Container";
import { TabPanel, tabA11yProps } from "../../components/Tabs/Tabs";

const ProfileView = ({ title, ...props }) => {

	const { profileData } = props;
	const [tabValue, setTabValue] = React.useState(0);
	const theme = useTheme();
	const handleTabChange = (e, newTabValue) => {
		setTabValue(newTabValue);
	};

	return (
		<DefaultTemplate>
			<ContentContainerTop>
				<Box sx={{ display: "flex", justifyContent: "space-between" }}>
					<PageTitle title={title} />
					<Box sx={{ paddingTop: 2, textAlign: "right" }}>
						Account Number: {isStringOfLength(profileData.accountNumber) ? profileData.accountNumber : TEXT_DATA_UNAVAILABLE}
					</Box>
				</Box>
			</ContentContainerTop>
			<ContentContainerBottom>
				<Grid container maxWidth={620} mb={8} mx="auto" /*spacing={2}*/>
					<Grid item xs={12}>
						<Tabs
							aria-label="Contact Information Tab"
							sx={{ marginBottom: 3 }}
							onChange={handleTabChange}
							value={tabValue}
						>
							<Tab label="Contact" value={0} {...tabA11yProps(0)} sx={{ color: `${theme.palette.common.black} !important` }} />
						</Tabs>
						<TabPanel index={0} value={tabValue}>
							<OverviewCard content={<ContactInfoList includeActions={true} />} headingText="Contact Information" />
						</TabPanel>
					</Grid>
				</Grid>
			</ContentContainerBottom>
		</DefaultTemplate>
	);
};

const mapStateToProps = state => ({
	profileData: state.profile.data
});

export default connect(mapStateToProps)(ProfileView);